











































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import BerkasFormPanel from "@/components/pemeriksaan/berkasRm/BerkasFormPanel.vue";
import AjukanAksesRevisiDialog from "@/components/pemeriksaan/AjukanAksesRevisiDialog.vue";
import { storeGeneralConsent } from "@/store/modules/GeneralConsentStore";
import GeneralConsentSvc from "@/services/GeneralConsent";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component({
  components: {
    BerkasFormPanel,
    AjukanAksesRevisiDialog
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardGeneralConsent extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get rm6(): string {
    const v = String(this.rm || "");
    return v.length > 6 ? v.slice(-6) : v;
  }

  isEditing = false;
  showForm = false;
  deleting = false;
  saving = false;
  finalizing = false;
  formValid = false;

  form: any = this.getEmptyForm();

  mounted() {
    this.reload();
  }

  reload() {
    storeGeneralConsent.getByRegister(this.register);
  }

  getEmptyForm() {
    return {
      consent_tindakan_medis_umum: false,
      consent_tata_tertib_rs: false,
      consent_kerahasiaan: false,
      rahasia_dikecualikan: "",
      consent_info_penyakit: false,
      penerima_info: [{ nama: "", hubungan: "" }],
      consent_pelepasan_info_medis: false,
      consent_peserta_didik: false,
      consent_kompetensi_dokter: false,
      consent_hak_kewajiban: false,
      consent_penitipan_barang: false,
      penanda_tangan_nama: "",
      penanda_tangan_hubungan: "",
      tempat_tanda_tangan: "Bantul"
    };
  }

  formatDate(date) {
    return getHumanDateTime(date);
  }

  get stateuser() {
    return userModule.user;
  }

  get stateConsent() {
    return storeGeneralConsent.consent;
  }

  get isFinalized(): boolean {
    return !!(this.stateConsent && this.stateConsent.is_finalized);
  }

  get adaBerkas(): boolean {
    return !!(this.stateConsent && this.stateConsent.berkas_count > 0);
  }

  get unlockedByRevision(): boolean {
    const c = this.stateConsent;
    return !!(c && !c.is_finalized && c.revision_request_id);
  }

  get cardReadOnly(): boolean {
    return this.readOnly && !this.unlockedByRevision;
  }

  get canEditState() {
    if (this.cardReadOnly) return false;
    if (!this.stateConsent) return false;
    return !this.isFinalized;
  }

  get statusLabel(): string {
    if (this.isFinalized) return "Final";
    if (this.unlockedByRevision) return "Dibuka untuk revisi";
    return "Draft";
  }

  get statusColor(): string {
    if (this.isFinalized) return "green";
    if (this.unlockedByRevision) return "amber darken-2";
    return "orange";
  }

  get consentItems() {
    const c = this.stateConsent;
    if (!c) return [];
    return [
      { label: "1. Persetujuan Tindakan Medis Umum", value: c.consent_tindakan_medis_umum },
      { label: "2. Ketaatan Peraturan RS", value: c.consent_tata_tertib_rs },
      { label: "3. Kerahasiaan Identitas Pasien", value: c.consent_kerahasiaan },
      { label: "4. Pemberian Informasi Kondisi Penyakit", value: c.consent_info_penyakit },
      { label: "5. Kuasa Pelepasan Informasi Medis", value: c.consent_pelepasan_info_medis },
      { label: "6. Keterlibatan Peserta Didik", value: c.consent_peserta_didik },
      { label: "7. Pemahaman Tugas dan Kompetensi Dokter", value: c.consent_kompetensi_dokter },
      { label: "8. Informasi Hak dan Kewajiban", value: c.consent_hak_kewajiban },
      { label: "9. Penitipan Barang Berharga", value: c.consent_penitipan_barang }
    ];
  }

  addPenerimaInfo() {
    if (this.form.penerima_info.length < 3) {
      this.form.penerima_info.push({ nama: "", hubungan: "" });
    }
  }

  removePenerimaInfo(idx: number) {
    this.form.penerima_info.splice(idx, 1);
  }

  startEdit() {
    const c = this.stateConsent;
    this.form = {
      consent_tindakan_medis_umum: c.consent_tindakan_medis_umum,
      consent_tata_tertib_rs: c.consent_tata_tertib_rs,
      consent_kerahasiaan: c.consent_kerahasiaan,
      rahasia_dikecualikan: c.rahasia_dikecualikan || "",
      consent_info_penyakit: c.consent_info_penyakit,
      penerima_info: c.penerima_info && c.penerima_info.length
        ? JSON.parse(JSON.stringify(c.penerima_info))
        : [{ nama: "", hubungan: "" }],
      consent_pelepasan_info_medis: c.consent_pelepasan_info_medis,
      consent_peserta_didik: c.consent_peserta_didik,
      consent_kompetensi_dokter: c.consent_kompetensi_dokter,
      consent_hak_kewajiban: c.consent_hak_kewajiban,
      consent_penitipan_barang: c.consent_penitipan_barang,
      penanda_tangan_nama: c.penanda_tangan_nama || "",
      penanda_tangan_hubungan: c.penanda_tangan_hubungan || "",
      tempat_tanda_tangan: c.tempat_tanda_tangan || "Bantul"
    };
    this.isEditing = true;
  }

  cancelEdit() {
    this.isEditing = false;
    this.showForm = false;
    this.form = this.getEmptyForm();
  }

  async simpan() {
    if (!(this.$refs.formConsent as any).validate()) return;
    this.saving = true;

    try {
      const penerimaInfo = this.form.consent_info_penyakit
        ? this.form.penerima_info.filter(p => p.nama && p.hubungan)
        : null;

      const payload = {
        register_id: this.register,
        pasien_rm: this.rm6,
        ...this.form,
        penerima_info: penerimaInfo,
        rahasia_dikecualikan: this.form.consent_kerahasiaan
          ? this.form.rahasia_dikecualikan
          : null
      };

      let resp;
      if (this.stateConsent && this.isEditing) {
        resp = await GeneralConsentSvc.update(this.stateConsent.id, payload);
      } else {
        resp = await GeneralConsentSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("General Consent berhasil disimpan. Silakan cetak untuk ditandatangani basah.");
        this.isEditing = false;
        this.showForm = false;
        this.form = this.getEmptyForm();
        this.reload();
      }
    } finally {
      this.saving = false;
    }
  }

  async finalisasi() {
    if (!this.stateConsent || this.finalizing) return;
    const q = confirm(
      "Finalisasi General Consent? Setelah difinalisasi dokumen terkunci dan hanya dapat diubah lewat pengajuan revisi."
    );
    if (!q) return;

    this.finalizing = true;
    try {
      const resp = await GeneralConsentSvc.finalize(this.stateConsent.id);
      if (resp.data.status == "1") {
        appModule.NoticeDelay(resp.data.message || "General Consent difinalisasi");
        this.reload();
      }
    } finally {
      this.finalizing = false;
    }
  }

  openUpload() {
    const panel = this.$refs.berkasPanel as any;
    if (panel && panel.openUpload) panel.openUpload();
  }

  onBerkasChanged() {
    this.reload();
  }

  cetakPdf() {
    GeneralConsentSvc.print(this.stateConsent.id);
  }

  async remove() {
    const q = confirm("Anda yakin akan menghapus General Consent ini?");

    if (q && !this.deleting) {
      this.deleting = true;

      try {
        const resp = await GeneralConsentSvc.destroy(this.stateConsent.id);
        if (resp?.status == 1) {
          appModule.NoticeDelay(resp.message);
          this.reload();
        }
      } finally {
        this.deleting = false;
      }
    }
  }
}
